export const mockPartnerSummaryReportRes = (body, params, options) => {
  const { guid = 'any' } = options;
  return {
    [guid]: {}
  };
};

export default mockPartnerSummaryReportRes;
